module.exports = __webpack_public_path__ + "static/media/contact_thumb.d9feec78.png";